import React, { Component } from 'react';
import { Button, Popover, Icon, Modal, message, Popconfirm } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import TableC from '../../basicElement/TableC';
import InvRemark from '../projectPercent/InvRemark';
import AcLog from '../projectPercent/AcLog';
import AcLogTable from '../projectPercent/AcLogTable';
import MoreRemark from '../projectPercent/MoreRemark';
import PercentCompletionChangeLog from './PercentCompletionChangeLog';
import { lineFeed } from '../../shared/formatElem';
import ExportModal from './ExportModal';
import Filter from './Filter';
import format from '../../shared/format';

class ProPercent extends Component {
    constructor(props) {
        super(props);
        this.isAreaLeader = false;
        this.PM_editable = false;
        this.PML_editable = false;
        this.state = {
            loading: false,
            searchParams: {},
            dataList: [],
            fteList: [],
            pagination: {
                current: 1,
                pageSize: 7,
            },
            investigationFinishes: [],
            acStatus: "OPEN",
        };
    }

    loadData = () => {
        this.setState({ loading: true });
        const { invId } = this.props;
        const { searchParams, pagination } = this.state;
        const { current } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.sumtotal.queryAllInvestigation,
            data: {
                offset: current,
                limit: 1,
                investigationId: invId,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { totalCount } = res;
                if (totalCount > 0) {
                    const { datas: [{ investigations = [], jdeInvestigationFinishes = [] }] = [{}] } = res;
                    const [{ ftes = [] } = {}] = jdeInvestigationFinishes;

                    const pSize = investigations.length + 6;
                    const ct = Number(pSize * totalCount) + (totalCount % 1 > 0 ? pSize : 0);
                    pagination.total = ct;
                    pagination.pageSize = pSize;
                    const { curRole } = sessionStorage;
                    const editable = (investigations || []).some(i => i.onlyAreaLeader == false);
                    this.isAreaLeader = (investigations || []).some(i => i.isAreaLeader);
                    this.PM_editable = (curRole === 'PM' && editable);
                    this.PML_editable = (curRole === 'PML' && editable);

                    this.setState({
                        loading: false,
                        pagination,
                        fteList: ftes,
                        dataList: investigations,
                        investigationFinishes: jdeInvestigationFinishes,
                    });
                } else {
                    this.PM_editable = false;
                    this.PML_editable = false;
                    this.setState({
                        loading: false,
                        dataList: [],
                        fteList: [],
                        pagination: {
                            current: 1,
                            pageSize: 7,
                            total: 0,
                        },
                    });
                }
            },
            errorResult: (() => {
                this.setState({ loading: false, });
            }),
        };
        $.sendRequest(options);
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1
        this.setState({
            pagination,
            searchParams: {
                ...params,
            },
        }, () => {
            this.loadData();
        });
    }

    exportAll = () => {
        this.exportRef.show();
    }

    toggleConfirm = (status, investigationId) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: status == 'CLOSE' ? `确定要关闭AC自动调整?` : `确定要打开AC自动调整?`,
            onOk: () => {
                this.toggleAC(status, investigationId);
            },
        });
    }



    toggleAC = (status, investigationId) => {
        const { dataList = [] } = this.state;
        const { invId } = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.sumtotal.setInvestigationAc}`,
            data: {
                status,
                investigationId: investigationId ? investigationId : ((invId == 0 && dataList.length) ? dataList[0].investigationId : invId),
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: (() => {
                this.setState({ loading: false });
            })
        };
        $.sendRequest(options);
    }

    remarkDelete = (investigationId, investigationFinishRemarkId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.deleteInvestigationFinishRemark,
            data: {
                investigationId,
                investigationFinishRemarkId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    showTransfinite = () => {
        this.props.showTransfinite(true);
    }



    viewPro = (value) => {
        this.props.showView(value)
    }

    getRemarkDom = () => {
        const { dataList = [] } = this.state;
        const { curRole } = sessionStorage;
        const len = dataList.length;
        const isShow = curRole === 'BO' || this.PM_editable || this.PML_editable || this.isAreaLeader;
        return (
            <div>
                {
                    len > 0 &&
                    (
                        len > 1 ?
                            <div>
                                {
                                    dataList.map((d, index) =>
                                        <div key={d.investigationFinishRemarkId} style={(len != (index + 1)) ? { borderBottom: "2px dashed #d6d4d4" } : null}>
                                            <h4 style={{ lineHeight: '36px' }}>
                                                <span className="proTableRemark">项目简称: {d.investigationName}</span>
                                                {
                                                    isShow &&
                                                    <div style={{ float: "right" }}>
                                                        <span style={{ color: '#0e77ca', cursor: 'pointer' , paddingRight:5}} onClick={() => this.showAcLogTable(d.investigationId)}>
                                                            AC开关日志
                                                        </span>
                                                        <span style={{ color: '#0e77ca', cursor: 'pointer'}} onClick={() => this.showInvRemark(d.investigationId)}>
                                                            添加备注
                                                        </span>

                                                    </div>

                                                }

                                            </h4>

                                            {
                                                (d.investigationFinishRemarks) && (d.investigationFinishRemarks).slice(0, 1).map((d, index) =>
                                                    <div>
                                                        <p style={{ textAlign: 'left', paddingTop: 5 }}>{format('joint', d.userName, d.modifyTime, 'roundBrackets')}
                                                            {
                                                                (isShow && d.type !== 'INV_TIME_UPDATE') &&
                                                                <span>
                                                                    <Popconfirm title='确认要删除吗?' onConfirm={() => this.remarkDelete(d.investigationId, d.investigationFinishRemarkId)} okText="确定" cancelText="取消">
                                                                        <Icon type="close"
                                                                            style={{ color: "red", position: "relative", top: 3, float: "right", cursor: "pointer" }}
                                                                        />
                                                                    </Popconfirm>
                                                                </span>
                                                            }
                                                        </p>
                                                        <p style={{ textAlign: 'left', paddingBottom: 15 }} className="tableRemark">{d.remark}</p>
                                                    </div>
                                                )
                                            }
                                            {
                                                (d.investigationFinishRemarks) &&
                                                <p style={{ textAlign: "right", marginBottom: "5px", color: '#0e77ca' }}>
                                                    <span style={{ cursor: "pointer" }} onClick={() => this.showMoreRemark(d.investigationId)} >查看更多&gt;&gt;</span>
                                                </p>
                                            }
                                        </div>)
                                }
                            </div>
                            :
                            <div>
                                {
                                    dataList.map(d =>
                                        <div>
                                            {
                                                isShow &&
                                                <span style={{ position: 'absolute', top: 20, right: 100, color: '#0e77ca', cursor: 'pointer' }} onClick={() => this.showAcLogTable(d.investigationId)}>
                                                    AC开关日志
                                                </span>
                                            }
                                            {
                                                isShow &&
                                                <span style={{ position: 'absolute', top: 20, right: 40, color: '#0e77ca', cursor: 'pointer' }} onClick={() => this.showInvRemark(d.investigationId)}>
                                                    添加备注
                                                </span>
                                            }
                                            {
                                                (d.investigationFinishRemarks) && (d.investigationFinishRemarks).slice(0, 3).map((d, index) =>
                                                    <div key={d.investigationFinishRemarkId} style={((index + 1) < 3) ? { borderBottom: "2px dashed #d6d4d4" } : null}>
                                                        <p style={{ textAlign: 'left', paddingTop: 5 }}>{format('joint', d.userName, d.modifyTime, 'roundBrackets')}
                                                            {
                                                                (isShow && d.type !== 'INV_TIME_UPDATE') &&
                                                                <span>
                                                                    <Popconfirm title='确认要删除吗?' onConfirm={() => this.remarkDelete(d.investigationId, d.investigationFinishRemarkId)} okText="确定" cancelText="取消">
                                                                        <Icon type="close"
                                                                            style={{ color: "red", position: "relative", top: 3, float: "right", cursor: "pointer" }}
                                                                        />
                                                                    </Popconfirm>
                                                                </span>
                                                            }
                                                        </p>
                                                        <p style={{ textAlign: 'left', paddingBottom: 15 }} className="tableRemark">{d.remark}</p>
                                                    </div>
                                                )
                                            }
                                            {
                                                ((d.investigationFinishRemarks) && (d.investigationFinishRemarks.length > 2)) &&
                                                <span style={{ position: "absolute", bottom: 15, right: 40, color: '#0e77ca', cursor: 'pointer' }} onClick={() => this.showMoreRemark(d.investigationId)}>
                                                    查看更多&gt;&gt;
                                                </span>
                                            }
                                        </div>
                                    )
                                }
                            </div>
                    )
                }
            </div>
        )
    }

    enhanceRender = (func, span1, span2) => {
        return (...rest) => {
            const [value, row, index] = rest;
            const { dataList } = this.state;
            const invMount = dataList.length;
            const obj = {
                children: value,
                props: {},
            };
            if (index < invMount) {
                func && func.apply(null, rest.concat(obj));
            } else if (index == invMount) {
                const { rowSpan = 6, colSpan = 0 } = span1 || {};
                obj.props.rowSpan = rowSpan;
                obj.props.colSpan = colSpan;
                if (colSpan === 3) {
                    obj.children = (
                        <div style={{ padding: '20px 40px' }}>
                            {this.getRemarkDom()}
                        </div>
                    );
                }
            } else if (index > invMount) {
                const { rowSpan = 0, colSpan = 0 } = span2 || {};
                obj.props.rowSpan = rowSpan;
                obj.props.colSpan = colSpan;
            }
            return obj;
        }
    }

    getColumns = () => {
        const { dataList, fteList } = this.state;
        const invMount = dataList.length;
        const { curRole, investigationSiteName } = sessionStorage;
        const columnNames = [{
            title: '序号',
            width: 80,
            dataIndex: 'num',
            key: 'num',
            fixed: 'left',
            render: this.enhanceRender((value, row, index, obj) => {
                if (index == 0) {
                    obj.props.rowSpan = invMount;
                } else {
                    obj.props.rowSpan = 0;
                }
                if (!row.allColor) {
                    obj.children = (
                        <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                            <span style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)' }}>{value}</span>
                        </div>
                    );
                }
            }, { rowSpan: 6, colSpan: 3 }, { rowSpan: 0, colSpan: 3 })
        }, {
            title: 'JDE主项目号',
            width: 120,
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            fixed: 'left',
            render: this.enhanceRender((value, row, index, obj) => {
                if (index == 0) {
                    obj.props.rowSpan = invMount;
                } else {
                    obj.props.rowSpan = 0;
                }
                if (!row.allColor) {
                    obj.children = (
                        <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                            <span style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)' }}>{value}</span>
                        </div>
                    );
                }
            })
        }, {
            title: '项目简称',
            width: 140,
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            render: this.enhanceRender((value, row, index, obj) => {
                const { notSignedJdeContractCode } = row;
                if (notSignedJdeContractCode) {
                    const contentNode = notSignedJdeContractCode.split(',').map((item, index) => {
                        if ((index % 2) != 0) {
                            return <span>{item}, <br /></span>
                        } else {
                            return <span>{item}, </span>
                        }
                    });
                    obj.children = (
                        <Popover placement="right" overlayClassName="propercent-pop" content={contentNode} title="该项目下未签署完成合同:">
                            <div>
                                <i className='pop'></i>
                                <div className='pop-div' onClick={() => this.viewPro(row)}>{value}</div>
                            </div>
                        </Popover>
                    );
                } else {
                    obj.children = <a onClick={() => this.viewPro(row)}>{value}</a>;
                }
            }),
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            fixed: 'left',
            width: 80,
            render: this.enhanceRender((value, row, index, obj) => {
                obj.children = lineFeed(value);
            }, { rowSpan: 1, colSpan: 0 }, { rowSpan: 1, colSpan: 0 }),
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            fixed: 'left',
            width: 80,
            render: this.enhanceRender((value, row, index, obj) => {
                obj.children = lineFeed(value);
            }, { rowSpan: 1, colSpan: 2 }, { rowSpan: 1, colSpan: 2 }),
        }, {
            title: '项目编号',
            width: 80,
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            render: this.enhanceRender(()=>{},{ rowSpan: 6, colSpan: 6 }),
        }, {
            title: '项目阶段',
            width: 80,
            dataIndex: 'stageNames',
            key: 'stageNames',
            render: this.enhanceRender(),
        }, {
            title: '计收入确认方式',
            width: 80,
            dataIndex: 'contractTypeName',
            key: 'contractTypeName',
            render: this.enhanceRender(),
        }, {
            title: 'PM工号',
            width: 80,
            dataIndex: 'investigationPmEmployeeCode',
            key: 'investigationPmEmployeeCode',
            render: this.enhanceRender(),
        }, {
            title: 'PM姓名',
            width: 80,
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            render: this.enhanceRender(),
        },
        {
            title: '领域leader',
            width: 100,
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            render: this.enhanceRender(),
        }
    ];
        const length = (fteList || []).length;
        (fteList || []).forEach((d, i) => {
            if (i < length - 2) {
                columnNames.push({
                    title: d.title,
                    dataIndex: `fteValue${i}`,
                    key: `fteValue${i}`,
                    width: 80,
                    render: (value, row, index) => {
                        if (row[`fteValue${i}isRed`] == '1') {
                            return <span style={{ color: "#f00" }}>{value}</span>;
                        } else {
                            return <span>{value}</span>;
                        }
                    }
                });
            } else {
                columnNames.push({
                    title: d.title,
                    dataIndex: `fteValue${i}`,
                    key: `fteValue${i}`,
                    width: 80,
                    fixed: 'right',
                    render: (value, row, index) => {
                        const { acStatus, investigationId, investigationName } = row;
                        if (investigationName && !investigationSiteName) {
                            if ((i == length - 2) && (curRole == "BO" || this.PML_editable)) {
                                return (
                                    <div className="inlineBlock">
                                        {value}
                                        <Button
                                            type="primary"
                                            onClick={
                                                () => this.acLog(investigationId, acStatus == 'OPEN' ? 'CLOSE' : 'OPEN')
                                            }
                                            style={{
                                                background: 'rgba(255, 165, 0, 0.92)',
                                                border: '1px solid rgba(255, 165, 0, 0.92)',
                                                padding: "inherit",
                                                paddingRight: "0px",
                                                paddingLeft: "0px",
                                                marginLeft: "3px",
                                                height: "23px"
                                            }}
                                        >
                                            {acStatus == "CLOSE" ? 'AC关' : 'AC开'}
                                        </Button>
                                    </div>
                                );
                            } else {
                                return <span>{value}</span>;
                            }
                        } else {
                            return <span>{value}</span>;
                        }
                    }
                });
            }
        });
        return columnNames;
    }

    getDataSource = () => {
        const { dataList, investigationFinishes } = this.state;
        if(dataList.length == 0){
            return []
        }
        let key = 0;
        const dataSource = [];
        (dataList || []).forEach((item, index) => {
            const params = {}
            if (item.investigationFinishes) {
                item.investigationFinishes[0].ftes.map((innerItem, innerIndex) => {
                    params[`fteValue${innerIndex}`] = innerItem.fteValue;
                    params[`fteValue${innerIndex}isRed`] = innerItem.isRed;
                })
                dataSource.push({
                    key: key++,
                    num: index + 1,
                    ...item,
                    ...params,
                });
            }
        });
        investigationFinishes.forEach((item, index) => {
            if (index) {
                const params = {}
                item.ftes.map((innerItem, innerIndex) => {
                    params[`fteValue${innerIndex}`] = innerItem.fteValue;
                    params[`fteValue${innerIndex}isRed`] = innerItem.isRed;
                })
                dataSource.push({
                    key: key++,
                    ...item,
                    ...params,
                });
            }
        });
        dataSource.forEach((el,index)=>{
            if(index){
                el.secondLineNames = el.userCompellation
            }
        })
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showInvRemark = (investigationId) => {
        this.invRemarkRef.show(investigationId);
    }

    showAcLogTable = (investigationId) => {
        this.acLogTableRef.show(investigationId)
    }


    acLog = (investigationId, opStatus) => {
        this.acLogRef.show(investigationId, opStatus);
    }


    showMoreRemark = (investigationId) => {
        this.moreRemarkRef.show(investigationId);
    }

    showChangeLog = () => {
        this.changeRef.show();
    }

    render() {
        const { loading, pagination, dataList, searchParams } = this.state;
        const { investigationName } = this.props;
        return (
            <div className="content project-percent">
                <div className="main" style={{ minHeight: "400px" }}>
                    <Filter
                        investigationName={investigationName}
                        search={this.search}
                        exportAll={this.exportAll}
                        canOverApply={this.PM_editable || this.PML_editable}
                        showTransfinite={this.showTransfinite}
                        showChangeLog={this.showChangeLog}
                    />
                    <TableC
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        loading={loading}
                        scrollY={550}
                        className="proPercent"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        rowClassName={(record, index) => {
                            if (record.color === 'yellow') {
                                return "light-yellow-bkg";
                            }
                        }}
                    />
                </div>
                <ExportModal ref={el => this.exportRef = el} searchParams={searchParams} />
                <InvRemark ref={el => this.invRemarkRef = el} loadData={this.loadData} />
                <AcLog ref={el => this.acLogRef = el} loadData={this.loadData} nowAcStatus={() => { }} />
                <AcLogTable ref={el => this.acLogTableRef = el} loadData={this.loadData} />
                <PercentCompletionChangeLog ref={el => this.changeRef = el} />
                <MoreRemark
                    ref={el => this.moreRemarkRef = el}
                    loadData={this.loadData}
                    list={dataList}
                    type='pro'
                />
            </div>
        );
    }
}

export default ProPercent;


// WEBPACK FOOTER //
// ./src/components/sumTotal/proPercent/index.js